import { createSelector } from 'reselect';

export const getDevList = state => {
    if (state.devices.get('list')) {
        return state.devices.getIn(['list', 'data']);
    }
    return undefined;
};

const getDevicesAreLoading = state => state.devices.getIn(['list', 'isLoading']);

/* ====================== SELECTORS ======================== */
export const getDeviceList = createSelector([getDevList], list => list && list.toJS());

export const getDeviceListIsLoading = createSelector(
    [getDevicesAreLoading],
    isLoading => isLoading
);
